import { render, staticRenderFns } from "./pointOfSales.vue?vue&type=template&id=215c8ce6&scoped=true"
import script from "./pointOfSales.vue?vue&type=script&setup=true&lang=js"
export * from "./pointOfSales.vue?vue&type=script&setup=true&lang=js"
import style0 from "./pointOfSales.vue?vue&type=style&index=0&id=215c8ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c8ce6",
  null
  
)

export default component.exports